export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="home-footer">
      © {year} Spicadust Inc.
    </footer>
  );
}
